import React, { useState } from 'react';
import { Redirect } from 'react-router';
import { Button } from 'primereact/button';
import { BarChart, YAxis, XAxis, Bar, LabelList } from 'recharts';
import { getGraficoReembolso } from '../Services/home.service';
import { formatMoney } from '../Utilities/FormatMoney';
import { ProgressSpinnerDemo } from '../../shared/components/progressSpinnerDemo/ProgressSpinnerDemo';
import moment from 'moment';
import 'moment/locale/es';
import { useGlobalContext } from '../../shared/context/global.context';
import { PCOM_ROUTES, PrivateRoutes, routeIncludes } from '../../shared/models/routes';

interface props {
    redirect: boolean;
    cursor: string;
}

export const GraficoReembolso = (props: props) => {
    const {allowedRoutes} = useGlobalContext()
    const [isRedirect, setIsRedirect] = useState<any>(false);
    const [dataresult, setDataresult] = useState<any>({});
    const [dimensions, setDimensions] = useState<any>({})
    const [spinnergraficoReembolso, setSpinnergraficoReembolso] = useState(true)
    const [totalesTra, setTotalesTra] = useState<any>({})
    const redirectDisable = allowedRoutes.some((r: { url: any; }) => routeIncludes({path: PCOM_ROUTES.REEMBOLSO_EXPRESS, url: r.url}));
    
    React.useEffect(() => {
        updateWindowDimensions();
        GraficosReembolso();
    }, []);

    const GraficosReembolso = async () => {
        const { data, status } = await getGraficoReembolso();
        setDataresult(fechaGraficoReembolso(data));
        setSpinnergraficoReembolso(false);
        setTotales(data);
    };

    const setTotales = (data : any) => {
      const totalPagado = data.graficos.reduce((acc: number, curr: any) => acc + (curr.processed || 0), 0);
      const totalEnProceso = data.graficos.reduce((acc: number, curr: any) => acc + (curr.inProgress || 0), 0);
      const totalProgramado = data.graficos.reduce((acc: number, curr: any) => acc + (curr.programmed || 0), 0);
      setTotalesTra({...totalesTra, totalPagado : totalPagado, totalEnProceso: totalEnProceso, totalProgramado : totalProgramado})
    }
    const limpiarFecha = (a: any) => {
        if (a.includes('-')) {
            return moment(a).format("MMM-DD")
        }
        else return a
    }
    
    const fechaGraficoReembolso = (data: any) => {
        let fechaFinal = data.graficos.map((item: any) => {
            return {
                inProgress: item.inProgress,
                processed: item.processed,
                programmed: item.programmed,
                labels: limpiarFecha(item.labels)
            };
        });
        return ({ graficos: fechaFinal })

    }
    
    async function updateWindowDimensions() {
        var factor = 0.75;
        if (window.innerWidth <= 1280)
            factor = 0.90;
        setDimensions({ width: window.innerWidth, height: window.innerHeight, factor: factor })
    };

    const renderCustomizedLabel = (props: { x?: any; y?: any; width?: any; height?: any; value?: any; }) => {
        const {
            x, y, width, height, value,
        } = props;
        const radius = 10;
        if (value == 0)
            return (<div></div>);
        else
            return (
                <g>
                    <text x={x + width / 2} y={y - radius} fill="#000" fontSize={12} textAnchor="middle" dominantBaseline="middle" >
                        {formatMoney(value, 0)}
                    </text>
                </g>
            );
    };

    const CustomizedAxisTick = (props: { x?: any; y?: any; width?: any; height?: any; value?: any; stroke?: any; payload?: any; }) => {
        const { x, y, stroke, payload } = props;

        return (
            <g transform={`translate(${x},${y})`}>
                <text x={0} y={0} dy={16} textAnchor="end" fill="#666" fontSize={14} transform="rotate(-25)">{payload.value}</text>
            </g>
        );
    };

    function setRedirect() {
        redirectDisable ? setIsRedirect({
            isRedirect: true
        })
        :<></>
    }

    if (isRedirect && props.redirect) {
        return <Redirect to={PrivateRoutes.REEMBOLSO_EXPRESS} />
    }

    
    return (
        <div>
            <div className="d-flex justify-content-end wrapper-button-pago-express">
            {
                redirectDisable ? <Button 
                    style={{color: 'white'}}
                    label="Pago Express" 
                    className='p-d-flex p-flex-row-reverse p-jc-around p-ai-center'
                    onClick={setRedirect}>
                    <i className="pi pi-money-bill p-mr-1" style={{fontSize: '1.25rem' }}></i>
                </Button>
                : <></>
            }
            </div>
            <a onClick={setRedirect} style={{ cursor: 'pointer' }}>
                <div className="d-flex justify-content-center">
                    <div style={{ display: "contents" }}>
                        {
                            spinnergraficoReembolso ? <ProgressSpinnerDemo />
                                : <BarChart width={dimensions.width * dimensions.factor}
                                    margin={{ top: 20, right: 30, left: -20, bottom: 50 }}
                                    height={300}
                                    data={dataresult.graficos}
                                    style={{ cursor: props.cursor }}
                                    className="text-center" >
                                    <YAxis tick={false} axisLine={false} interval={0} />
                                    <XAxis
                                        interval={0}
                                        dataKey="labels"
                                        tick={CustomizedAxisTick}
                                        tickCount={30} />
                                    <Bar dataKey="processed" stackId="a" fill="#162056">
                                        <LabelList dataKey="processed" position="top" content={renderCustomizedLabel} />
                                    </Bar>
                                    <Bar dataKey="inProgress" stackId="a" fill="#0085ca">
                                        <LabelList dataKey="inProgress" position="top" content={renderCustomizedLabel} />
                                    </Bar>setRedirect
                                    <Bar dataKey="programmed" stackId="a" fill="#80c2e4">
                                        <LabelList dataKey="programmed" position="top" content={renderCustomizedLabel} />
                                    </Bar>
                                </BarChart>
                        }
                    </div>
                </div>
            </a>
            {!spinnergraficoReembolso && <div className="row ribbon">
                <div className="col-4">
                    <div className="ribbon-wrapper text-center">
                        <p className="font-weight-bold n1 c3">
                            <span className="n2">$ </span>
                            {formatMoney(totalesTra.totalPagado, 0)},
                            <span className="n2">{(formatMoney(totalesTra.totalPagado)).split(',')[1]}</span>
                        </p>
                        <p className="ribbon-circle ribbon-refund d-flex align-items-center justify-content-center">Pagados</p>
                    </div>
                </div>
                <div className="col-4">
                    <div className="ribbon-wrapper text-center">
                        <p className="font-weight-bold n1 c3">
                            <span className="n2">$ </span>
                            {formatMoney(totalesTra.totalEnProceso, 0)},
                            <span className="n2">{(formatMoney(totalesTra.totalEnProceso)).split(',')[1]}</span>
                        </p>
                        <p className="ribbon-circle ribbon-process d-flex align-items-center justify-content-center">En proceso</p>
                    </div>
                </div>
                <div className="col-4">
                    <div className="ribbon-wrapper text-center">
                        <p className="font-weight-bold n1 c3">
                            <span className="n2">$ </span>
                            {formatMoney(totalesTra.totalProgramado, 0)},
                            <span className="n2">{(formatMoney(totalesTra.totalProgramado)).split(',')[1]}</span>
                        </p>
                        <p className="ribbon-circle ribbon-programmed d-flex align-items-center justify-content-center">Programados</p>
                    </div>
                </div>
            </div>}
        </div>
    )
}

export default GraficoReembolso